import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
import { CommonPathWay } from "../../Components/CommonPathWay";
const initialCommonState = {
  companyCount: "",
  contactCount: "",
  totalCredits: 0,
  totalpeopleCredits: 0,
  selectedFields: [],
  selectedBundles: [],
  selectedpeopleFields: [],
  selectedpeopleBundles: [],
  calculated: false
};
class SubScriptionPageStore {
  tableData = [];
  selectedPlanData = {
    title: "Choose from the plans suitable for your organisation",
    currentCredits: 0,
    plans: [
      {
        credits: 5000,
        pricePerCredit: 0.95,
        currency: "GBP",
        totalPrice: 4750,
        discount: "10% Off",
        buttonText: "Purchase Now",
      },
    ],
  };
  settings = 100;
  plansData = {
    title: "Credits Pricing Plans",
    plans: [],
  };
  selectedCredits = 5000;
  selectedPrice = 4750;
  selectedDiscount = 5;
  commonRootStoreMap;
  constructor(rootstore) {
    this.rootstore = rootstore;
    this.commonRootStoreMap = new Map(Object.entries(initialCommonState));
    makeAutoObservable(this);
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonRootStoreMap.set(key, value);
      }
    });
  }
  getThevalue(key) {
    return this.commonRootStoreMap.get(key);
  }
  setSelectedCredits = (value) => {
    this.selectedCredits = value;
    const pricePlan =
      this.rootstore?.SubScriptionPageStore?.plansData?.plans.find(
        (p) =>
          p.credits === this.rootstore?.SubScriptionPageStore?.selectedCredits
      );
    this.setSelectedPrice(pricePlan?.price);
    this.setSelectedDiscount(pricePlan?.discount);
  };
  setSelectedPrice = (value) => {
    this.selectedPrice = value;
  };
  setSelectedDiscount = (value) => {
    this.selectedDiscount = value;
  };
  getSubscriptionInfo = async () => {
    try {
      const response = await commonAxios(
        "/getSubscritpionData",
        "POST",
        {},
        {}
      );
      if (response?.data) {
        runInAction(() => {
          this.plansData = response?.data?.pricingPlans;
          this.plansData.plans = response?.data?.pricingPlans?.plans || [];
          this.selectedPlanData = response?.choosePlan;
          this.settings = response?.data?.setting;
        });
      }
    } catch (e) { }
  };
  handlePurchase = async () => {
    try {
      const response = await commonAxios(
        "/create-checkout-session",
        "POST",
        {},
        {
          id: this.settings?.id,
          price: (this.selectedPrice * this.settings?.pricing).toString(),
        }
      );
      if (response?.data) {
        window.location.href = response?.data;
      }
    } catch (e) { }
  };
  handlePricepayment = async (price) => {
    try {
      const response = await CommonPathWay(
        "/payment/session/create",
        "POST",
        {},
        {
          price: price,
        }
      );
      if (response) {
        window.location.href = response?.data?.url;
      }
    } catch (e) {
    }
  };
  handleCreditConfigurationTableData = async () => {
    try {
      const response = await commonAxios(
        "/getCreditConfigList",
        "POST",
        {},
        {}
      );
      if (response?.data) {
        runInAction(() => {
          this.tableData = response.data;
        });
      }
    } catch (e) { }
  };

  handleresetCalculator = () => {
    this.commonRootStoreMap.set("companyCount", "");
    this.commonRootStoreMap.set("contactCount", "");
    this.commonRootStoreMap.set("selectedBundles", []);
    this.commonRootStoreMap.set("selectedpeopleBundles", []);
    this.commonRootStoreMap.set("calculated", false);
  };
}
export default SubScriptionPageStore;
